import React, { useEffect } from 'react';
import { MainRouter } from '../navigation';
import { Providers } from './providers';
import useAuth from '../auth/feature/auth';
import { ErrorBoundary } from './error-boundary';
import '../../index.css';

function AppContainer() {
  const { checkAuth } = useAuth();
  useEffect(() => {
    checkAuth();
  }, []);

  return (
    <ErrorBoundary>
      <Providers>
        <MainRouter />
      </Providers>
    </ErrorBoundary>
  );
}

export default AppContainer;
